import CustomizableGeneric from './CustomizableGeneric';

class WebSite extends CustomizableGeneric {
  getTypeName = () => 'WebSite';

  getFields = () => ['potentialAction', 'url'];
}

export default WebSite;
